import { gql } from "@apollo/client";

export const SEND_MAIL_MESSAGE = gql`
  mutation SendMailMessageMutation($input: SendMailMessageInput!) {
    sendMailMessage(input: $input) {
      ok
      error
      id
    }
  }
`;

export const MAIL_MESSAGE = gql`
  query MailMessageQuery($id: Int!) {
    mailMessage(id: $id) {
      ok
      error
      result {
        id
        direction
        subject
        fromAddress
        toAddresses
        body
        sentAt
        customerId
        customer {
          id
          name
        }
      }
    }
  }
`;

export const MAIL_MESSAGES = gql`
  query MailMessagesQuery($where: MailMessagesFiltersInput!) {
    mailMessages(where: $where) {
      ok
      error
      total
      results {
        id
        direction
        subject
        fromAddress
        toAddresses
        body
        sentAt
        customerId
        customer {
          id
          name
        }
      }
    }
  }
`;
